<script setup>
import UseSvg from "common/vue/components/UseSvg.vue";

const emits = defineEmits(["click"]);
</script>

<template>
  <a class="canva-trigger" href="javascript:void(0);" @click.stop="emits('click')">
    <UseSvg icon="canva" class="canva-trigger__icon" />
  </a>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";
@import "frontend/init/jiffy/print-settings";

.canva-trigger {
  $this: &;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;

  &--made {
    padding: 12px;
    border: 1px solid $pod-gray-modern-300;
    border-radius: 12px;
    text-decoration: none;
    transition: box-shadow 0.3s;
    box-shadow: 0 0 0 $white inset;

    &:focus,
    &:hover {
      box-shadow: 0 0 0 4px $white inset;
    }

    #{$this}__text {
      color: $pod-gray-modern-900;
      font-size: 17px;
      font-weight: 500;

      @include with-desktop {
        color: $white;
      }
    }
  }

  &--dtf {
    height: 100%;
  }

  &__icon {
    width: 46px;
    height: 15px;
  }

  &__text {
    color: $black-light;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: -0.4px;
  }
}
</style>
